import { makeStyles } from 'tss-react/mui';

const NAV_INSET = 1;

export const useProductGalleryNavButtonsStyles = makeStyles()((theme) => ({
  root: {
    position: 'absolute',
    zIndex: 2,
    top: '50%',
    left: theme.spacing(NAV_INSET),
    right: theme.spacing(NAV_INSET),
    display: 'flex',
    justifyContent: 'space-between',
    transform: 'translateY(-50%)',
    pointerEvents: 'none',
  },
  buttonSlot: {
    display: 'flex',
    transition: theme.transitions.create(['opacity', 'visibility'], {
      duration: theme.transitions.duration.short,
      easing: theme.transitions.easing.easeInOut,
    }),
    '@media (prefers-reduced-motion: reduce)': {
      transition: 'none',
    },
  },
  buttonSlotHidden: {
    opacity: 0,
    visibility: 'hidden',
  },
  button: {
    pointerEvents: 'auto',
  },
  borderless: {
    '&&': {
      border: 'none',
    },
  },
}));
